import {
  PropertiesSettings
} from '../../../../core/configuration/properties-settings';
import {
  NumericOperationManager
} from '../../../utils/numeric-operation-manager';
import {
  Input,
  Component,
  OnInit,
  forwardRef,
  ElementRef,
  ViewChild,
  EventEmitter,
  Output,
  AfterViewInit,
  SimpleChanges
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  AbstractControl
} from '@angular/forms';
import {
  NgbTooltipConfig
} from '@ng-bootstrap/ng-bootstrap';
import {
  Subscription,
  Subject,
  Observable,
  Observer
} from 'rxjs';
import {
  HttpClient
} from '@angular/common/http';

declare var $: any;

export const TEXT_CURRENCY_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => InputTextCurrencyComponent),
  multi: true
};

@Component({
  selector: '[textInputCurrency]',
  templateUrl: 'input-text-currency.component.html',
  providers: [TEXT_CURRENCY_VALUE_ACCESSOR, NgbTooltipConfig]
})
export class InputTextCurrencyComponent implements ControlValueAccessor, AfterViewInit, OnInit {
  @Input() labelInput: string;
  @Input() control: AbstractControl;
  @Input() location: string;
  @Input() mandatory: boolean;
  @Input() maxValue: string;
  @Input() maxValueLimit: number = PropertiesSettings.MAX_VALUE_DECIMAL;
  @Input() minValueLimit: number = 0;
  @Input() showMaxMinLabel: boolean = false;
  @Input() isNaturalNumber: boolean;
  @Input() acceptNegative: boolean;
  @Input() defaultValue: string;
  @Input() submitPending: boolean;
  @Input() checkFormat: boolean;
  @Input() currency: string = '';
  @ViewChild('dinput') el: ElementRef;
  @Output() onReturn: EventEmitter < string > = new EventEmitter < string > ();

  private _value: string;
  private input: any;
  private internalValue: string;
  private placeHolderTxt: string;
  public enableObservable: Observable < boolean > ;
  private subscription: Subscription = null;
  private enableObserver: Observer < boolean > ;
  controlValid: boolean = true;
  private onTouchedCallback: () => void = () => {};
  private onChangeCallback: (_: any) => void = () => {};
  randomId: string = this.getRandomId();

  constructor(private httpService: HttpClient) {

  }

  ngOnInit(): void {
    if (!this.submitPending) {
      this.createServiceSubscription();
      this.placeHolderTxt = 'Inserire ' + this.labelInput;
    } else {
      this.placeHolderTxt = '';
    }
    if (!this.mandatory) {
      this.mandatory = false;
    }

    this.internalValue = this.defaultValue ? this.defaultValue : '';

  }

  ngOnChanges(changes: SimpleChanges) {
    if(this.internalValue){

      if (this.maxValueLimit && parseFloat(this.internalValue.replace(',', '.')) > this.maxValueLimit) {
        this.controlValid = false;
      } else {
        this.controlValid = true;
      }
    }
  }

  ngAfterViewInit() {
    this.input = this.el.nativeElement as HTMLInputElement;
  }


  private createServiceSubscription() {
    this.enableObservable = new Observable < boolean > (observer => {
      this.enableObserver = observer;
      if (this.enableObserver) {
        this.submitPending = true;
      } else {
        this.submitPending = false;
      }
    });
  }

  validate(event: any) {
    let theEvent = event || window.event;
    let key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
    let regex = /^[0-9]+\,{0,1}([0-9]{1,2}){0,1}$/g;
    if (this.isNaturalNumber) {
      regex = /^[0-9]+$/g;
    }
    if (this.acceptNegative) {
      regex = /^(-)?([0-9]+\,{0,1}([0-9]{1,2}){0,1})?$/g;
    }
    let value = '';
    let valueCheck = '';
    if (this.internalValue) {
      value = this.internalValue.toString().split('.').join('');
    }
    if (theEvent.target.selectionStart || theEvent.target.selectionStart === 0) {
      if (theEvent.target.selectionStart !== theEvent.target.selectionEnd) {
        value = value.substring(0, theEvent.target.selectionStart) + value.substring(theEvent.target.selectionEnd, value.length);
      }
      let valueSplit1 = value.substring(0, theEvent.target.selectionStart);
      let valueSplit2 = value.substring(theEvent.target.selectionStart, value.length);
      valueCheck = valueSplit1 + key + valueSplit2;
    } else {
      valueCheck = value + key;
    }
    if (!regex.test(valueCheck) || (this.isNaturalNumber && ((valueCheck).replace('-', '')).length > (this.maxValue ? String(this.maxValue).length : 25))) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) {
        theEvent.preventDefault();
      }
    }
  }

  validateChange() {
    let regex = /^\d{1,3}(?:\.\d{3})*(?:,\d{1,2})?$|^\d+(?:,\d{1,2})?$/;
    if (this.isNaturalNumber) {
      regex = /^[0-9]+$/g;
    }
    if (this.acceptNegative) {
      regex = /^(-)?([0-9]+\,{0,1}([0-9]{1,2}){0,1})?$/g;
    }

    if (this.internalValue && this.internalValue.toString().trim().length > 0) {
      if (!regex.test(this.internalValue)) {
        this.internalValue = '';
        this.input.value = '';
      }
      if (this.maxValue && this.stringToNumber(this.internalValue) > this.maxValue) {
        this.internalValue = this.defaultValue ? this.defaultValue : '';
        if (!this.defaultValue) {
          this.placeHolderTxt = 'Valore MAX: ' + this.maxValue;
        }
      }
      // debugger;
      if (this.maxValueLimit && parseFloat(this.internalValue.replace(',', '.')) > this.maxValueLimit) {
        this.controlValid = false;
      } else {
        this.controlValid = true;
      }
      if (this.internalValue) {
        this.internalValue = NumericOperationManager.transformToThousands(this.internalValue);

        if (this.isNaturalNumber) {
          this.internalValue = this.internalValue.substring(0, this.internalValue.length - 3);
        }
      }
      this.input.value = this.internalValue;
      this._value = this.stringToNumber(this.internalValue);
    } else {
      this.internalValue = '';
      this.input.value = '';
      this._value = '';
    }

    if (this._value && this._value.trim().length > 0) {
      this.onChangeCallback(Number(this._value));
      this.onReturn.emit(this._value);
    } else {
      this.onChangeCallback(undefined);
      this.onReturn.emit(undefined);
    }
  }

  stringToNumber(value: string): string {
    if (value) {
      value = value.split('.').join('').replace(',', '.');
    }
    return value;
  }

  currency_transform(value: number): string {
    let locale = PropertiesSettings.LOCALE_IT;
    value = value ? value : 0;
    let importo = value.toLocaleString(locale, {
      minimumFractionDigits: 2
    });
    return importo;
  }

  numberToString(value: string): string {
    let valueToReplace = '' + value;
    value = valueToReplace.replace('.', ',');
    return value;
  }

  removePoint() {
    if(this.internalValue) this.internalValue = this.internalValue.split('.').join('');
  }

  writeValue(value: any): void {
    this._value = value;
    if (this._value && this._value.toString().trim().length > 0) {
      this.internalValue = NumericOperationManager.transformToThousands(this.numberToString(this._value));
      if (this.isNaturalNumber) {
        this.internalValue = this.internalValue.substring(0, this.internalValue.length - 3);
      }
    } else {
      this.internalValue = '';
    }
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  getRandomId(length: number = 10): string {
    return crypto.randomUUID();
  }
}
